import { render, staticRenderFns } from "./PositionBasedAssignSelect.vue?vue&type=template&id=2c774dcf&scoped=true&"
import script from "./PositionBasedAssignSelect.vue?vue&type=script&lang=ts&"
export * from "./PositionBasedAssignSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c774dcf",
  null
  
)

export default component.exports